module.exports = __webpack_public_path__ + "static/img/iron 2.49084f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/iron 2.png
// module id = jg3T
// module chunks = 35